export default "__VITE_ASSET__Dvfsl4oZ__"